import { inject, Injectable, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { map } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Breadcrumb } from './dto/breadcrumb';
import { ActivatedRoute } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  router = inject(Router);
  routerEvents$ = this.router.events;
  activatedRoute = inject(ActivatedRoute);

  breadcrumbs = toSignal(
    this.routerEvents$.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => {
        const breadcrumbs: Breadcrumb[] = [];
        let route = this.activatedRoute.root;
        while (route.firstChild) {
          route = route.firstChild;
        }
        if (route.snapshot.data['breadcrumbs']) {
          const breadcrumbsData = route.snapshot.data['breadcrumbs'] as Breadcrumb[] | undefined;
          if (breadcrumbsData) {
            breadcrumbs.push(...breadcrumbsData);
          }
        }
        return breadcrumbs;
      }),
    ),
    { initialValue: [] },
  );
}
